import * as React from 'react';
import * as _ from 'underscore';

import { IEntityValuesHash } from '../../../pdc-platform/src/ts/stores/EntityModelsStore';
import { IParameterFieldBaseOptions } from '../ts/ParameterFieldBase';
import { ISuggestionValue } from './SuggestionListField';

export { GetValuesResult, IGetValuesResult, ISuggestionValue } from './SuggestionListField';

import {
    ISelectedItemsDisplayComponentBaseProps,
    SelectedItemsDisplayComponent
} from './selectors/SelectedItemsDisplayComponent';

export interface ISuggestionSelectOptions extends IParameterFieldBaseOptions {
    values?: string[] | ISuggestionValue[];
    displayValues?: ISuggestionValue[];
    allowNull?: boolean;
    allowAdding?: boolean;
    singleSelectMode?: boolean;
    setFocus?: boolean;
}

export interface ISuggestionSelectProperties extends ISelectedItemsDisplayComponentBaseProps {
    value?: string[] | ISuggestionValue[];
    tooltip?: string;
    options?: ISuggestionSelectOptions;
}

function normalizeValue(values: string[] | ISuggestionValue[]): ISuggestionValue[] {
    if (values == null) {
        return [];
    }

    const result: ISuggestionValue[] = [];

    if (Array.isArray(values)) {
        values.forEach((value) => {
            if (value != null) {
                if (typeof value === 'string') {
                    if (value.length > 0) {
                        result.push({
                            value: value
                        });
                    }
                } else if (typeof value === 'number') {
                    result.push({
                        value: (value as any).toString()
                    });
                } else {
                    result.push(value);
                }
            }
        });
    } else {
        result.push({
            value: (values as any).toString()
        });
    }

    return result;
}

export function SuggestionSelect(props: ISuggestionSelectProperties) {
    const value = normalizeValue(props.value);
    const options = props.options ?? {};

    return (
        <div className="suggestion-select" title={props.tooltip || props.placeholder}>
            <SelectedItemsDisplayComponent
                mainComponent={true}
                value={value}
                displayValues={props.displayValues ?? options.displayValues}
                keySelect={props.keySelect}
                sortByDisplayValue={props.sortByDisplayValue}
                allowNull={props.allowNull ?? options.allowNull}
                allowAdding={props.allowAdding ?? options.allowAdding}
                allowReordering={props.allowReordering}
                singleSelectMode={props.singleSelectMode ?? options.singleSelectMode}
                types={props.types}
                listThreshold={props.listThreshold}
                shortView={true}
                placeholder={props.placeholder}
                usePlaceholderAsTitle={props.usePlaceholderAsTitle}
                tabIndex={props.tabIndex}
                width={props.width ?? options.width}
                minWidth={props.minWidth ?? options.minWidth}
                readOnly={props.readOnly ?? options.readOnly}
                hideSelectAllAndClear={props.hideSelectAllAndClear}
                hideSearchField={props.hideSearchField}
                selectFirstItemByDefault={props.selectFirstItemByDefault}
                checkValueExistsInValueList={props.checkValueExistsInValueList}
                theme={props.theme}
                name={props.name}
                setFocus={props.setFocus ?? options.setFocus}
                notSetFocusOnClose={props.notSetFocusOnClose}
                minSelectedItemsCellWidth={props.minSelectedItemsCellWidth}
                glob={props.glob}
                getValues={props.getValues}
                getDisplayValue={props.getDisplayValue}
                getElementComponent={props.getElementComponent}
                onFocus={props.onFocus}
                onBlur={props.onBlur}
                onChange={props.onChange}
            />
        </div>
    );
}

export function convertToSuggestionValues(values: string[]): ISuggestionValue[] {
    if (values == null) {
        return;
    }

    const result: ISuggestionValue[] = [];

    values.forEach((value) => {
        if (value != null && value.length > 0) {
            result.push({
                value: value
            });
        }
    });

    return result;
}

export function convertFromHashToDisplayValues(valueHash: IEntityValuesHash, displayKey = 'name'): ISuggestionValue[] {
    const result: ISuggestionValue[] = [];

    _.each(valueHash, (value, key) => {
        if (value != null) {
            result.push({
                value: key,
                displayValue: value[displayKey],
                type: value.type
            });
        }
    });

    return result;
}
